import React from 'react';
import { CONTACTS } from '../../constants/contacts';

const email = process.env.REACT_APP_CONTACT_EMAIL;

export const Contacts: React.FC = () => {
  const contactStyle: React.CSSProperties = {
    maxWidth: '1000px',
    padding: '2.5rem',
    background: 'rgba(77, 166, 255, 0.1)',
    borderRadius: '16px',
    border: '1px solid rgba(77, 166, 255, 0.3)',
    lineHeight: '1.9',
  };

  const paragraphStyle: React.CSSProperties = {
    marginBottom: '1.5rem',
    fontSize: '1.15rem',
    color: '#ffffff',
  };

  const linkStyle: React.CSSProperties = {
    color: '#66b3ff',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
  };

  const headingStyle: React.CSSProperties = {
    fontSize: 'clamp(1.75rem, 4vw, 2.4rem)',
    fontWeight: 'bold',
    color: '#66b3ff',
    marginBottom: '2rem',
    textAlign: 'center',
  };

  return (
    <div style={contactStyle}>
      <h1 style={headingStyle}>Контактна інформація</h1>
      <p style={paragraphStyle}>
        {CONTACTS.organizationName}
      </p>
      <p style={paragraphStyle}>
        <strong>📍 Адреса:</strong>{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href={CONTACTS.address.mapUrl}
          style={linkStyle}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#99d6ff')}
          onMouseLeave={(e) => (e.currentTarget.style.color = '#66b3ff')}
        >
          {CONTACTS.address.full}
        </a>
        <strong>📞 Телефон:</strong>{' '}
        <a 
          href={`tel:${CONTACTS.phone.tel}`}
          style={linkStyle}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#99d6ff')}
          onMouseLeave={(e) => (e.currentTarget.style.color = '#66b3ff')}
        >
          {CONTACTS.phone.display}
        </a>
      </p>
      <p style={paragraphStyle}>
        <strong>📧 Електронна пошта:</strong>{' '}
        <a 
          href={`mailto:${email}`}
          style={linkStyle}
          onMouseEnter={(e) => (e.currentTarget.style.color = '#99d6ff')}
          onMouseLeave={(e) => (e.currentTarget.style.color = '#66b3ff')}
        >
          {email}
        </a>
      </p>
      <p style={{ textAlign: 'center', marginTop: '2rem' }}>
        <a
          target="_blank"
          rel="noreferrer"
          style={{
            fontSize: '3rem',
            color: '#1877f2',
            transition: 'transform 0.3s ease, color 0.3s ease',
            display: 'inline-block',
          }}
          href={CONTACTS.facebook}
          aria-label="Facebook сторінка"
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)';
            e.currentTarget.style.color = '#3b5998';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.color = '#1877f2';
          }}
        >
          <span className="fa fa-facebook-square" />
        </a>
      </p>
    </div>
  );
};
